import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { ProblematicBookingPage } from "@/features/tasks/pages/problematic-booking-page/problematic-booking-page";
import { problematicBookingFilterSchema } from "@/features/tasks/schemas/problematic-booking-filter.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/tasks/problematic-bookings/"
)({
	head: () => pageTitle("Problematic Bookings"),
	component: ProblematicBookingPage,
	validateSearch: zodValidator(problematicBookingFilterSchema),
});
